import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {api} from 'api';
import {Buttons, Modal, Typography, Warn} from 'components';
import {useUser} from 'hooks';
import {modal} from 'utils';
import config from 'config';

import {makeStyles} from '@material-ui/styles';
import {Box} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 600
    },
    elements: {
        marginTop: 22,
        marginBottom: 22
    }
}));

function AutoLogoutModal({open}) {
    const classes = useStyles();

    const {user, setUser} = useUser();

    useEffect(() => {
        ['individual', 'individual_transmission', 'collective'].includes(user.origin) &&
        open &&
        modal.open('auto_logout');
        // eslint-disable-next-line
    }, [open]);

    useEffect(() => {
        if (
            modal.isOpen('auto_logout') &&
            (window.location.pathname === '/error-page' || window.location.pathname === '/presentation')
        ) {
            setUser({
                origin: user.origin
            });
            api.get(`/login/oauth/authorization/${user.origin || 'collective'}`)
                .then((response) => (window.location.href = response.data))
                .catch(() =>
                    ['individual', 'individual_transmission', 'collective'].includes(user.origin)
                        ? (window.location.href = config.AXA_CLIENT_SPACE_URL[process.env.REACT_APP_ENVIRONMENT])
                        : (window.location.href = '/')
                );
        }

        // eslint-disable-next-line
    }, [user.origin, modal.isOpen('auto_logout')]);

    if (
        (modal.isOpen('auto_logout') &&
            (window.location.pathname === '/error-page' || window.location.pathname === '/presentation')) ||
        !['individual', 'individual_transmission', 'collective'].includes(user.origin)
    )
        return null;

    return (
        <Modal
            hash="auto_logout"
            className={classes.root}
            title={'logOut.title'}
            icon={
                <Warn
                    message=""
                    color="white"
                />
            }
            disableBackdropClick
            disableEscapeKeyDown
            noCloseButton
        >
            <Box className={classes.elements}>
                <img
                    src={`${process.env.PUBLIC_URL}/images/log-out.svg`}
                    alt={'Log out'}
                />
            </Box>
            <Box className={classes.elements}>
                <Typography
                    variant="h5"
                    localization={'logOut.message1'}
                />
                <Typography
                    variant="h5"
                    localization={'logOut.message2'}
                />
            </Box>
            <Box className={classes.elements}>
                <Buttons.Default
                    label={'logOut.button'}
                    color="blue"
                    center
                    centerText
                    onClick={() => {
                        setUser({
                            origin: user.origin
                        });
                        api.get(`/login/oauth/authorization/${user.origin || 'collective'}`)
                            .then((response) => (window.location.href = response.data))
                            .catch(() =>
                                ['individual', 'individual_transmission'].includes(user.origin)
                                    ? (window.location.href =
                                        config.AXA_CLIENT_SPACE_URL[process.env.REACT_APP_ENVIRONMENT])
                                    : (window.location.href = '/')
                            );
                    }}
                />
            </Box>
        </Modal>
    );
}

AutoLogoutModal.propTypes = {
    open: PropTypes.bool
};

export default AutoLogoutModal;
